export const en: Record<string, string> = {
  'brand.name': 'Dr Newen IA',
  'brand.subtitle': 'Clinical Triage System',
  'brand.tagline': 'Train your clinical reasoning with real cases, AI and hand tracking.',

  'auth.welcome': 'Welcome',
  'auth.login': 'Sign in',
  'auth.register': 'Create account',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.name': 'Name',
  'auth.role': 'Role',
  'auth.role.student': 'Student',
  'auth.role.teacher': 'Teacher',
  'auth.enter': 'Enter',
  'auth.create': 'Create account',
  'auth.disclaimer': 'For educational purposes only. Not a substitute for clinical judgement.',
  'auth.password.min': 'Min 8 characters',

  'sidebar.cases.title': 'Test cases',
  'sidebar.session.title': 'Clinical session',
  'sidebar.tools.title': 'Tools',
  'sidebar.camera.title': 'Camera',
  'sidebar.gestures.title': 'Gestures',
  'sidebar.shortcuts.title': 'Shortcuts',
  'sidebar.logout': 'Sign out',
  'sidebar.myProgress': 'My progress',

  'help.title': 'Help',
  'help.subtitle': 'Simulator quick reference.',
  'help.tab.gestures': 'Gestures',
  'help.tab.mouse': 'Mouse',
  'help.tab.keyboard': 'Shortcuts',
  'help.tab.exams': 'Exams',
  'help.tab.patterns': 'Patterns',
  'help.tab.triage': 'Triage',

  'common.close': 'Close',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.loading': 'Loading…',
  'common.error': 'Error',
};
